/**
 * Audit Context
 *
 * Holds the "who is acting" user id for audit stamping, so domain services can
 * stamp `inclusionUserId` / `lastModifiedUserId` without threading the id through
 * every mutation signature. `auditService` reads it as the default `userId`.
 *
 * Intended for a **single-user process** (the client app): set it once when the
 * session resolves and clear it on logout. **Do NOT use it on a shared server**
 * (concurrent requests would clash) — there, pass `{ userId }` explicitly to the
 * stamp methods instead (it takes precedence over the context).
 */
class AuditContext {
    setUserId(userId) {
        this.userId = userId;
    }
    getUserId() {
        return this.userId;
    }
    clear() {
        this.userId = undefined;
    }
}
export const auditContext = new AuditContext();
//# sourceMappingURL=auditContext.js.map